import { render, staticRenderFns } from "./CalendarSettingsInfo.vue?vue&type=template&id=09263ec9&"
import script from "./CalendarSettingsInfo.vue?vue&type=script&lang=js&"
export * from "./CalendarSettingsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports